/**
 * Rich Text - WYSIWYG Content
 */

// Deps
import { createComponent } from "react-fela";
import { gutters } from "~/styleguide";
import { fluid } from "~/styleguide/utils";

import PostContent from "~/components/shared/post-content";
import { ContentMaxWidth } from "~/components/layout/max-width";

export default function RichText({ block }) {
    const { content, anchor_id } = block;

    if (!content) return null;

    return (
        <Container id={anchor_id} className="module-rich-text">
            <ContentMaxWidth>
                <PostContent content={content} largeHeading={true} />
            </ContentMaxWidth>
        </Container>
    );
}

const Container = createComponent(
    () => ({
      "> div div ol li": {
        paddingLeft: "12px",
        marginBottom: "12px"

      },
      "> div div ul li": {
        paddingLeft: "12px",
        marginBottom: "12px"

      },
        extend: [
            fluid("paddingH", gutters.default),
            fluid("paddingV", gutters.vertical)
        ]
    }),
    "div",
    ["id"]
);
